module.exports = __webpack_public_path__ + "static/additional_insurance-1d2b3487803686fe6d19d57f864da3f8.jpg";